// extracted by mini-css-extract-plugin
export default {"root":"SignUpForm_root__ZyUqW","submit":"SignUpForm_submit__bs36q","fieldInput":"SignUpForm_fieldInput__9B6HQ","submittedLabel":"SignUpForm_submittedLabel__gn8dC"};